<template>

  <b-modal
      id="modal-production-order-label-print-history-detail"
      ref="modal"
      title="Detalhes da Impressão"
      size="xl"
      no-close-on-backdrop>

    <template #modal-footer="{ ok }">
      <t-button
          @click="ok()"
          class="pr-5 pl-5 ml-3"
          text="Fechar"
          primary/>
    </template>


    <!-- DADOS DA IMPRESSÃO -->

    <b-row>

      <t-input
          v-model="historyItem.createdDate"
          datetime
          label="Data da Impressão"
          cols="4"
          fixed/>

      <t-input
          v-model="historyItem.createdUser"
          label="Responsável"
          cols="4"
          fixed/>

      <t-input
          v-model="getPrintNumber"
          label="Via"
          cols="2"
          fixed/>

      <t-input
          v-model="historyItem.quantity"
          label="Quantidade"
          cols="2"
          fixed/>

    </b-row>


    <!-- IDENTIFICAÇÃO -->

    <b-row>

      <t-input
          v-model="historyItem.productionOrderCodeLabel"
          label="Ordem de Fabricação"
          cols="3"
          fixed/>

      <t-input
          v-model="historyItem.label"
          label="Etiqueta"
          cols="3"
          fixed/>


      <t-input
          v-model="historyItem.labelVersion"
          label="Layout"
          cols="2"
          fixed/>

      <t-input
          v-model="historyItem.printer"
          label="Impressora"
          cols="4"
          fixed/>

    </b-row>




    <!-- CONTEÚDO IMPRESSO -->

    <div class="mt-3">

      <div class="mb-2">
        <strong>Conteúdo da Etiqueta Impressa</strong>
      </div>

      <div class="label-print-preview">

        <div
            v-if="historyItem.printLabel"
            v-html="historyItem.printLabel">
        </div>

        <div
            v-else
            class="text-muted text-center p-4">
          Conteúdo da etiqueta não disponível.
        </div>

      </div>

    </div>


  </b-modal>

</template>


<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageListMixin from "@/mixins/page/pageListMixin"

export default {

  name: "ProductionOrderLabelPrintHistoryDialog",

  mixins: [
    pageDefaultMixin,
    pageListMixin
  ],

  props: {

    historyItem: {
      type: Object,
      required: true
    }

  },
  methods: {

  },
  computed: {
    getPrintNumber(){
      return this.historyItem.printNumber + 'ª'
    }
  }
}

</script>


<style>

.label-print-preview {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 20px;
  min-height: 350px;
/*  max-height: 450px;*/
  overflow: auto;
}

.label-print-preview > div {
  width: 100%;
}


/*VALIDO SOMENTE PARA POLIMIX */
.polimix_label{
  width:320px;
  border:1px solid #000;
  background:#fff;
  color:#000;
  font-family:Arial,Helvetica,sans-serif;
  position:relative;
  overflow:hidden;
  box-sizing:border-box;
  padding:10px;
  margin: auto;
}

.polimix_label *{
  box-sizing:border-box;
}

.polimix_variant_default{background:#fff;}
.polimix_variant_warning{background:#ffd966;}
.polimix_variant_danger{background:#f4b183;}
.polimix_variant_success{background:#c6e0b4;}

.polimix_frame{
  border:1px solid #000;
}

.polimix_section{
  border-bottom:1px solid #000;
  padding:8px 9px;
}

.polimix_header{
  height:135px;
}

.polimix_company{
  font-size:29px;
  font-weight:900;
  line-height:1;
  letter-spacing:.3px;
  margin-bottom:9px;
}

.polimix_address{
  font-size:11px;
  font-weight:bold;
  line-height:1.4;
  letter-spacing:1.1px;
}

.polimix_product{
  padding:12px 9px 5px;
}

.polimix_product_row{
  display:flex;
  align-items:flex-start;
}

.polimix_qr{
  width:78px;
  height:78px;
  background:#d9d9d9;
  border:1px solid #999;
  display:flex;
  align-items:center;
  justify-content:center;
  font-size:8px;
  font-weight:bold;
}

.polimix_product_code{
  flex:1;
  text-align:center;
  font-size:43px;
  font-weight:900;
  letter-spacing:2px;
  line-height:1;
  padding-top:9px;
}

.polimix_trace{
  margin-top:9px;
  font-size:11px;
  font-weight:900;
  letter-spacing:1.2px;
  white-space:nowrap;
}

.polimix_row{
  display:flex;
  width:100%;
}

.polimix_col{
  flex:1;
}

.polimix_title{
  font-size:8px;
  font-weight:900;
  text-transform:uppercase;
  letter-spacing:.3px;
  line-height:1.1;
}

.polimix_value{
  font-size:12px;
  font-weight:900;
  line-height:1.05;
  margin-top:5px;
}

.polimix_value_big{
  font-size:20px;
  font-weight:900;
  line-height:1;
  margin-top:4px;
}

.polimix_lot{
  padding-top:12px;
}

.polimix_packaging{
  padding-top:15px;
}

.polimix_identification{
  padding-top:10px;
}

.polimix_secondary{
  padding-top:11px;
}

.polimix_barcode{
  height:40px;
  background:#d9d9d9;
  border:1px solid #999;
  margin-top:5px;
  display:flex;
  align-items:center;
  justify-content:center;
  font-size:8px;
  font-weight:bold;
}

.polimix_barcode_small{
  height:34px;
  background:#d9d9d9;
  border:1px solid #999;
  margin-top:5px;
  display:flex;
  align-items:center;
  justify-content:center;
  font-size:8px;
  font-weight:bold;
}

.polimix_barcode_text{
  font-size:7px;
  font-weight:bold;
  text-align:center;
  margin-top:2px;
}

.polimix_physical{
  font-size:21px;
  font-weight:900;
  line-height:1;
  margin-top:7px;
}

.polimix_package{
  font-size:13px;
  font-weight:900;
  line-height:1;
  margin-top:6px;
}

.polimix_quality{
  display:flex;
  align-items:center;
  justify-content:center;
  text-align:center;
  font-size:30px;
  font-weight:900;
  letter-spacing:.4px;
  padding:0 7px;
}

.polimix_version{
  position:absolute;
  right:14px;
  bottom:12px;
  font-size:7px;
  font-weight:bold;
  opacity:.55;
}

.polimix_product_rejected{
  flex:1;
  padding-left:15px;
  font-size:24px;
  font-weight:900;
  line-height:1.05;
  letter-spacing:1px;
}

.polimix_rejected_origin{
  height:82px;
  padding-top:10px;
}

.polimix_rejected_reason{
  font-size:12px;
  font-weight:900;
  line-height:1.1;
  margin-top:6px;
  letter-spacing:.5px;
}

.polimix_rejected_details{
  padding:14px 9px;
  font-size:16px;
  font-weight:900;
  line-height:1.6;
}


.polimix_shipping_header{
  height:82px;
  padding:0;
}

.polimix_shipping_company,
.polimix_shipping_destination{
  padding:10px;
}

.polimix_shipping_company{
  flex:1.1;
  display:flex;
  align-items:center;
  font-size:24px;
  font-weight:900;
  border-right:1px solid #000;
}

.polimix_shipping_destination{
  flex:1;
}

.polimix_shipping_registration{
  height:95px;
  padding:8px 12px;
}

.polimix_shipping_registration_number{
  font-size:40px;
  font-weight:900;
  line-height:.9;
  text-align:right;
}

.polimix_shipping_customer{
  height:26px;
  padding:10px 12px;
}

.polimix_shipping_text{
  padding:14px 10px;
  font-size:13px;
  line-height:1.4;
  text-align:justify;
}

.polimix_shipping_footer{
  height:85px;
  padding:10px 12px;
  display:flex;
  align-items:center;
}

.polimix_shipping_footer_title{
  font-size:21px;
  font-weight:900;
  line-height:1;
}

</style>